import { render, staticRenderFns } from "./SquareSocial.vue?vue&type=template&id=3a9a37fc"
import script from "./SquareSocial.vue?vue&type=script&lang=js"
export * from "./SquareSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports